<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between">
    <h5 class="mb-0">Member Profile</h5>
    <ol class="breadcrumb mb-0 ps-0">
        <li class="breadcrumb-item">
            <a routerLink="/">
                <i class="ri-home-8-line"></i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item fw-semibold">Member Profile</li>
    </ol>
</div>

<div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0" fxLayoutGap.md="0">
    <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.lg="33%" fxFlex.md="100%" class="col">

        <div
            class="profile-card-box border-radius bg-white box-shadow mb-25"
            [class.component-dark-theme]="themeService.isDark()"
            [class.card-borderd-theme]="themeService.isCardBorder()"
            [class.card-border-radius]="themeService.isCardBorderRadius()"
            [class.component-rtl-enabled]="themeService.isRTLEnabled()"
        >
            <div class="top border-top-radius position-relative">
                <img src="assets/img/welcome.png" alt="welcome">
                <h4 class="main-color">Welcome to Tagus Dashboard !</h4>
                <p class="main-color">You have done 68% 😎 more sales today. Check new badge in profile.</p>
            </div>
            <div class="bottom">
                <div class="d-md-flex align-items-end justify-content-space-between">
                    <div class="profile-box position-relative">
                        <img src="assets/img/user/user15.jpg" class="rounded-circle" alt="user">
                        <h5 class="fw-semibold">Andrew Bruns</h5>
                        <span class="d-block gray-color">Programmer</span>
                    </div>
                    <div class="impression-box text-center">
                        <div class="chart">
                            <apx-chart
                                [series]="chartOptions.series!"
                                [chart]="chartOptions.chart!"
                                [plotOptions]="chartOptions.plotOptions!"
                                [colors]="chartOptions.colors!"
                                [labels]="chartOptions.labels!"
                                [fill]="chartOptions.fill!"
                            ></apx-chart>
                        </div>
                        <span class="d-block">Excellent</span>
                        <h5 class="mb-0 fw-semibold gray-color">Impression Share</h5>
                    </div>
                </div>
            </div>
        </div>

        <app-mp-personal-info></app-mp-personal-info>

        <app-mp-activity-timeline></app-mp-activity-timeline>

    </div>
    <div fxFlex="67%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.lg="67%" fxFlex.md="100%" class="col">

        <app-mp-stats></app-mp-stats>

        <app-mp-overview></app-mp-overview>

        <app-mp-my-tasks></app-mp-my-tasks>

    </div>
</div>